// 该文件专门用于创建整个应用的路由器
import Vue from "vue";
import VueRouter from "vue-router";
// 解决两次访问相同路由地址报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Layout",
    component: () => import("../views/Layout.vue"),
    redirect: "/home", //因为layout页面时布局页面，没有路由信息，为防止白屏需要重定向到home
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          title: "首页",
          keepAlive: true, // 需要缓存
        },
        component: () => import("../views/home"), //按需加载的页面
      },
      {
        path: "/customer/customerlist",
        name: "customerlist",
        meta: {
          parentname: "供应商管理",
          title: "供应商基础信息管理",
        },
        component: () => import("../views/customer/customerlist"),
      },
      {
        path: "/customer/contractlist",
        name: "contractlist",
        meta: {
          title: "供应商合同管理",
          parentname: "供应商管理",
        },
        component: () => import("../views/customer/contractlist"),
      },
      {
        path: "/settlement/rent",
        name: "rent",
        meta: {
          title: "仓租设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/rent"),
      },
      {
        path: "/settlement/materials",
        name: "materials",
        meta: {
          title: "物料运价设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/materials"),
      },
      {
        path: "/settlement/storagefee",
        name: "storagefee",
        meta: {
          title: "物料仓储费设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/storagefee"),
      },
      {
        path: "/settlement/infofee",
        name: "infofee",
        meta: {
          title: "信息费设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/infofee"),
      },
      {
        path: "/settlement/managefee",
        name: "managefee",
        meta: {
          title: "管理费设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/managefee"),
      },
      {
        path: "/settlement/freightfee",
        name: "freightfee",
        meta: {
          title: "运费结算系数设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/freightfee"),
      },
      // {
      //   path: "/settlement/waybill",
      //   name: "waybill",
      //   meta: {
      //     title: "运单结算设置",
      //     parentname:'结算设置'
      //   },
      //   component: () => import("../views/settlement/waybill"),
      // },
      {
        path: "/settlement/waytype",
        name: "waytype",
        meta: {
          title: "运单类型设置",
          parentname: "结算设置",
        },
        component: () => import("../views/settlement/waytype"),
      },
      {
        path: "/settlemanager/joblist",
        name: "joblist",
        meta: {
          title: "配送费结算待办",
          parentname: "配送费结算管理",
        },
        component: () => import("../views/settlemanager/joblist"),
      },
      {
        path: "/settlemanager/jobdo",
        name: "jobdo",
        meta: {
          title: "配送费结算办理",
          parentname: "配送费结算管理",
          keepAlive: true, // 需要缓存
        },
        component: () => import("../views/settlemanager/jobdo"),
      },
      {
        path: "/settlemanager/detail",
        name: "detail",
        meta: {
          title: "配送费结算单详情",
          parentname: "配送费结算管理",
          parentpath: "/settlemanager/jobdo",
        },
        component: () => import("../views/settlemanager/detail"),
      },
      {
        path: "/settlemanager/detailprint",
        name: "detailprint",
        meta: {
          title: "结算单详情打印",
          parentname: "结算单详情",
        },
        component: () => import("../views/settlemanager/detailprint"),
      },
      {
        path: "/settlemanager/jobaudit",
        name: "jobaudit",
        meta: {
          title: "配送反审与上传",
          parentname: "配送费结算管理",
        },
        component: () => import("../views/settlemanager/jobaudit"),
      },
      {
        path: "/settlemanager/jobinvoice",
        name: "jobinvoice",
        meta: {
          title: "配送费结算开票",
          parentname: "配送费结算管理",
        },
        component: () => import("../views/settlemanager/jobinvoice"),
      },
      {
        path: "/jsrent/rentlist",
        name: "rentlist",
        meta: {
          title: "仓租结算代办",
          parentname: "仓租结算管理",
        },
        component: () => import("../views/jsrent/rentlist"),
      },
      {
        path: "/jsrent/rentdo",
        name: "rentdo",
        meta: {
          title: "仓租结算办理",
          parentname: "仓租结算管理",
          keepAlive: true, // 需要缓存
        },
        component: () => import("../views/jsrent/rentdo"),
      },
      {
        path: "/jsrent/rentaudit",
        name: "rentaudit",
        meta: {
          title: "仓租反审与上传",
          parentname: "仓租结算管理",
        },
        component: () => import("../views/jsrent/rentaudit"),
      },
      {
        path: "/jsrent/rentinvoice",
        name: "rentinvoice",
        meta: {
          title: "仓租结算发票办理",
          parentname: "仓租结算管理",
        },
        component: () => import("../views/jsrent/rentinvoice"),
      },
      {
        path: "/jsrent/jsdetail",
        name: "jsdetail",
        meta: {
          title: "仓租结算结算单详情",
          parentname: "仓租结算管理",
          parentpath: "/settlemanager/jobdo",
        },
        component: () => import("../views/jsrent/jsdetail"),
      },
      {
        path: "/jsrent/jsprint",
        name: "jsprint",
        meta: {
          title: "仓租结算单详情打印",
          parentname: "仓租结算单详情",
        },
        component: () => import("../views/jsrent/jsprint"),
      },

      //默认路由
      {
        path: "/user/index",
        name: "user",
        meta: {
          title: "用户中心",
          parentname: "系统设置",
        },
        component: () => import("../views/user/index.vue"),
      },
      {
        path: "/sysset/entinfo",
        name: "entinfo",
        meta: {
          title: "当前企业信息设置",
          parentname: "系统设置",
        },
        component: () => import("../views/sysset/entinfo"),
      },
      {
        path: "/sysset/sysusermg",
        name: "sysusermg",
        meta: {
          title: "系统用户管理",
          parentname: "系统设置",
        },
        component: () => import("../views/sysset/sysusermg"),
      },
      {
        path: "/querysum/ruku",
        name: "ruku",
        meta: {
          title: "入库单查询",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/ruku"),
      },
      {
        path: "/querysum/chuku",
        name: "chuku",
        meta: {
          title: "出库单查询",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/chuku"),
      },
      {
        path: "/querysum/itemsfinish",
        name: "itemsfinish",
        meta: {
          title: "已发物料查询",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/itemsfinish"),
      },
      {
        path: "/querysum/itemsaudit",
        name: "itemsaudit",
        meta: {
          title: "已审物料查询",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/itemsaudit"),
      },
      {
        path: "/querysum/itemsfinishsum",
        name: "itemsfinishsum",
        meta: {
          title: "已发物料统计",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/itemsfinishsum"),
      },
      {
        path: "/querysum/itemsauditsum",
        name: "itemsauditsum",
        meta: {
          title: "已审物料统计",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/itemsauditsum"),
      },
      {
        path: "/querysum/storestatistics",
        name: "storestatistics",
        meta: {
          title: "当前库存统计",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/storestatistics"),
      },
      {
        path: "/querysum/storequery",
        name: "storequery",
        meta: {
          title: "当前库存查询",
          parentname: "查询统计",
        },
        component: () => import("../views/querysum/storequery"),
      },
    ],
  },
  /*   {
    path: "/smartview",
    name: "smartview",
    meta: {
      title: "智慧驾驶舱",
      parentname:'嘉恒储运'
    },
    component: () => import("../views/home/smartview"),
  }, */
  {
    path: "/login",
    name: "login",
    meta: {
      title: "嘉恒储运发动机结算系统",
    },
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "*",
    name: "notfount",
    component: () => import("../views/login/404.vue"),
  },
];
const router = new VueRouter({
  //mode: 'history',
  routes,
});
export default router;
